import React from 'react'
import Provider from '@@/core/plugin-model/Provider';
import { ModelsProvider } from './model';

export function dataflowProvider(element, args = {}){
    return <ModelsProvider {...args} >
                <Provider {...args}>{element}</Provider>
           </ModelsProvider>
}
// generated at 2025/8/22 09:24:41 by sui v3.1.124